import * as React from "react"

import {LoadingIndicatorIcon} from "../icons"
import {twMerge} from "libs/twmerge"

/**
 * @typedef {object} ButtonProps
 * @property {React.ReactNode} children
 * @property {boolean} [loading]
 * @property {keyof variantClassNameMap} [variant]
 */

/**
 * @type {React.FC<ButtonProps & import('react').ButtonHTMLAttributes<HTMLButtonElement>>}
 */
const Button = ({
  className = "",
  loading = false,
  variant = "primary",
  children,
  disabled,
  ...restProps
}) => {
  return (
    <button
      {...restProps}
      disabled={disabled || loading}
      className={twMerge(
        `
        relative flex min-h-[40px] items-center justify-center gap-[6px]
        typo-v3-button rounded-[24px] px-4 py-3 text-center
      `,
        variantClassNameMap[variant],
        className,
      )}
    >
      {children}
      {loading && (
        <LoadingIndicatorIcon className="h-[14px] w-[14px] animate-spin" />
      )}
    </button>
  )
}

const variantClassNameMap = {
  primary:
    "text-white bg-black active:bg-[#686868] disabled:bg-[#9B9B9B] disabled:text-[#E8E8E8]",
  secondary: `
    text-dark bg-gray-light active:bg-gray-silver disabled:bg-gray-silver
  `,
  alert: "text-white bg-error active:bg-[#A4304C] disabled:bg-[#A4304C]",
}

export default Button
